import { useRef } from "react";

export const useDataRef = <Type>(data: Type) => {
  const ref = useRef(data);
  ref.current = data;
  return ref;
};
